export enum OrderItemPageActivityLogMessageActionTypeEnum {
  VALIDATED = "VALIDATED",
  REFUSED = "REFUSED",
}
